(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.ckeditorconfig
   * @description
   * # ckeditorconfig
   * Constant in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .constant('ckeditorconfig', {
      toolbarGroups: [
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        { name: 'forms', groups: [ 'forms' ] },
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'others', groups: [ 'others' ] },
        '/',
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'about', groups: [ 'about' ] }
      ],

      removeButtons: 'Subscript,Image,Source,Superscript',

      language: 'pt-br',

      extraPlugins: 'justify'
    });

}());
